import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  const images = [
    'https://readdy.ai/api/search-image?query=Gritty%20Chinese%20crime%20drama%20scene%20with%20two%20men%20in%20dark%20alley%2C%20neon%20lights%2C%20tense%20atmosphere%2C%20film%20noir%20style%2C%20dramatic%20shadows%2C%20cinematic%20color%20grading%20with%20deep%20blues%20and%20warm%20highlights&width=700&height=400&seq=media-01&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Shanghai%20cityscape%20in%201990s%20aesthetic%20with%20vintage%20neon%20signs%2C%20wet%20streets%20reflecting%20golden%20light%2C%20nostalgic%20atmosphere%2C%20film%20grain%20texture%2C%20warm%20amber%20and%20teal%20tones%2C%20cinematic%20composition&width=700&height=400&seq=media-02&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Abstract%20interpretation%20of%20cosmic%20civilizations%20and%3B%20radiotelescope%20array%20under%20starry%20sky%2C%20sci-fi%20aesthetic%2C%20mysterious%20distant%20galaxy%2C%20deep%20blue%20and%20purple%20atmosphere%2C%20cinematic%20wide%20shot&width=700&height=400&seq=media-03&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Industrial%20northeast%20China%20factory%20town%20covered%20in%20first%20snow%2C%20lonely%20train%20tracks%2C%20melancholic%20atmosphere%2C%20desaturated%20warm%20tones%2C%20cinematic%20composition%2C%20quiet%20and%20poignant%20mood&width=700&height=400&seq=media-04&orientation=landscape',
  ];

  return (
    <section id="media" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-950">
            精选好剧
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            口碑爆款，每一部都值得细细品味
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, idx) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={images[idx]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center group-hover:bg-accent-500/80 transition-colors">
                    <i className="ri-play-fill text-xl text-white ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md text-xs font-medium bg-black/60 text-white">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-start justify-between gap-2 mb-1.5">
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <span className="whitespace-nowrap flex-shrink-0 flex items-center gap-1 text-xs font-medium text-accent-600">
                    <i className="ri-star-fill text-accent-500"></i>
                    {item.rating}
                  </span>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}